// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1--k1","errorLogs":"EditorFooter_errorLogs__I_MKr"};